import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';

export default function NotFound() {
  return (
    <div className="py-24 bg-stone-50 min-h-[calc(100vh-80px)] flex items-center justify-center">
      <Helmet>
        <title>404 Siden blev ikke fundet - Campen Camping</title>
        <meta name="description" content="Siden blev ikke fundet." />
      </Helmet>

      <div className="mx-auto max-w-md px-6 text-center flex flex-col items-center">
        <div className="bg-[#67aedd]/10 text-[#67aedd] p-6 rounded-full text-4xl mb-6 shadow-sm">
          <i className="fa-solid fa-compass-drafting" />
        </div>
        <h1 className="text-4xl font-serif font-bold text-[#0f0d0e] mb-2">404 - Siden blev ikke fundet</h1>
        <p className="text-stone-600 text-sm leading-relaxed mb-8">
          Beklager, men siden du leder efter findes ikke eller er blevet flyttet. Brug menuen i toppen eller klik herunder for at komme tilbage.
        </p>
        <div className="flex flex-wrap gap-4 justify-center">
          <Link
            to="/"
            className="bg-[#67aedd] hover:bg-[#5aa1cc] text-white font-bold px-6 py-3 rounded-full text-sm shadow-sm transition-colors"
          >
            Gå til Forsiden
          </Link>
          <Link
            to="/feriehuse"
            className="bg-stone-200 hover:bg-stone-300 text-[#0f0d0e] font-semibold px-6 py-3 rounded-full text-sm transition-colors"
          >
            Se Feriehuse
          </Link>
        </div>
      </div>
    </div>
  );
}
